<ng-container *accessController="[
  'AppealGrievance',
  'OperationsAdmin',
  'Operations',
  'Internal',
  'LetterMapsManager'
]">
  <div
    *accessView="['CareCoordination.Write']"
    class="flex justify-end mb-4"
    >
    <button
      pButton
      label="Add"
      aria-label="Add"
      icon="pi pi-plus"
      iconPos="left"
      type="button"
      (click)="onAddAspire()"
    ></button>
  </div>
</ng-container>

<p-table
  scrollDirection="both"
  scrollHeight="flex"
  [columns]="cols"
  [value]="aspireInfo"
  [paginator]="true"
  [alwaysShowPaginator]="false"
  [rows]="10"
  [scrollable]="true"
  [loading]="isLoading"
  >
  <ng-template let-columns pTemplate="header">
    <tr>
      @if (aspireInfo?.length) {
        <th style="width: 5rem"></th>
      }
      @for (col of columns; track col) {
        <th [style]="col.style">
          {{ col.header }}
        </th>
      }
    </tr>
  </ng-template>
  <ng-template let-aspire let-columns="columns" pTemplate="body">
    <tr>
      <td class="text-center" style="width: 5rem">
        <ng-container *accessController="[
          'AppealGrievance',
          'OperationsAdmin',
          'Operations',
          'Internal',
          'LetterMapsManager'
        ]">
          <ng-container *accessView="['CareCoordination.Write']">
            <button
              pButton
              class="p-button-rounded p-button-text p-button-lg"
              type="button"
              icon="pi pi-check"
              (click)="onEditAspire(aspire)"
              >
              <i class="pi pi-pencil"></i>
            </button>
          </ng-container>
        </ng-container>
      </td>
      <td [style]="columns[0].style">{{ aspire.referred ? 'yes' : 'no' }}</td>
      <td [style]="columns[1].style">{{ aspire.referredDate | date: 'MM/dd/yyyy' }}</td>
      <td [style]="columns[2].style">{{ aspire.enrolled ? 'yes' : 'no' }}</td>
      <td [style]="columns[3].style">{{ aspire.enrolledDate | date: 'MM/dd/yyyy' }}</td>
      <td [style]="columns[4].style">{{ aspire.status }}</td>
      <td [style]="columns[5].style">{{ aspire.stagingStatus }}</td>
      <td class="width-text" [style]="columns[6].style">{{ aspire.mostRecentAssessmentDate | date: 'MM/dd/yyyy' }}</td>
      <td [style]="columns[7].style">
        <span class="truncate" tooltipStyleClass="tooltip-xl-size" [pTooltip]="aspire.primaryDiagnosis">
          {{ aspire.primaryDiagnosis }}
        </span>
      </td>
      <td [style]="columns[8].style">{{ aspire.dischargeDate | date: 'MM/dd/yyyy' }}</td>
      <td [style]="columns[9].style">
        <span class="truncate" tooltipStyleClass="tooltip-xl-size" [pTooltip]="aspire.dischargeReason">
          {{ aspire.dischargeReason }}
        </span>
      </td>
      <td [style]="columns[10].style">{{ aspire.palliativePerformanceScale }}</td>
      <td class="col-email" [style]="columns[11].style">
        <span class="truncate" tooltipStyleClass="tooltip-xl-size" [pTooltip]="aspire.createdBy">
          {{ aspire.createdBy }}
        </span>
      </td>
      <td [style]="columns[12].style">{{ aspire.createdOn | utcToLocal: 'MM/dd/yyyy, h:mm a' }}</td>
      <td class="col-email" [style]="columns[13].style">
        <span class="truncate" tooltipPosition="left" tooltipStyleClass="tooltip-xl-size" [pTooltip]="aspire.modifiedBy">
          {{ aspire.modifiedBy }}
        </span>
      </td>
      <td [style]="columns[14].style">{{ aspire.modifiedOn | utcToLocal: 'MM/dd/yyyy, h:mm a' }}</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td class="w-full" colspan="10">
        No records found
      </td>
    </tr>
  </ng-template>
</p-table>

